import axios from 'axios';
import {storageAvailable} from '../base/utils';

class ExhibitsData {
    constructor() {}

    static async get(exhibitsUrl) {
        let exhibits = ExhibitsData.load();

        if (!exhibits) {
            return new Promise((resolve, reject) => {
                axios.get(exhibitsUrl)
                    .then(response => {
                        if (response && response.status === 200) {
                            exhibits = ExhibitsData.parse(response.data);
                            resolve(exhibits);
                        }
                    })
                    .catch(error => {
                        console.warn(error);
                        reject();
                    });
            });
        } else {
            return Promise.resolve(exhibits);
        }
    }

    static load() {
        let exhibits;

        if (storageAvailable('localStorage')) {
            try {
                let lang = document.documentElement.lang,
					exhibitsDataStr = window.localStorage.getItem('exhibits-' + lang),
                    exhibitsData = JSON.parse(exhibitsDataStr);

                if (exhibitsData.ttl >= Date.now()) {
                    exhibits = exhibitsData.data;
                }
            } catch (e) {

            }
        }

        return exhibits;
    }

    static parse(data) {
        let exhibits = {};

        for (let i = 0, n = data.length; i < n; i++) {
            if (data[i].slug) {
                exhibits[data[i].slug] = data[i];
            }
        }

        ExhibitsData.save(exhibits);

        return exhibits;
    }

    static save(exhibits) {
        if (storageAvailable('localStorage')) {
            let lang = document.documentElement.lang,
				exhibitsData = {
                    data: exhibits,
                    ttl: Date.now() + 24 * 60 * 60 * 1000
                },
                exhibitsDataStr = JSON.stringify(exhibitsData);

            try {
                window.localStorage.setItem('exhibits-' + lang, exhibitsDataStr);
            } catch(e) {
                console.warn(e);
            }
        }
    }
}

export default ExhibitsData;
